import axios from 'axios';

export const usersAxios = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URI}/users`,
});